/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@gasbuddy/react-components';
import Chevron from '../chevron';
import ListDropdownWrapper from '../list-dropdown-wrapper';
import styles from './styles.css';

const { api, getQueryParameters, getOrgLogoUrl } = require('../../../lib/bputils').default;

class StationListSelector extends React.Component {
  static propTypes = {
    showAllStationsList: PropTypes.bool,
    showWatchedStationsList: PropTypes.bool,
    onStationListChange: PropTypes.func,
  }

  static defaultProps = {
    showAllStationsList: true,
    showWatchedStationsList: true,
    onStationListChange: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedItemId: 0,
      stationLists: [],
      stationListOptions: null,
      isOpen: false,
    };
    this.setDropdownContainer = this.setDropdownContainer.bind(this);
  }

  componentDidMount = () => {
    window.addEventListener('mousedown', this.globalOnClickHandle, false);
    const queryParams = getQueryParameters();
    if (queryParams) {
      if (queryParams.stationListId) {
        this.setSelectedStationListId(queryParams.stationListId);
      }
    }
    this.getStationLists();
  }

  componentWillUnmount = () => {
    window.removeEventListener('mousedown', this.globalOnClickHandle);
  }

  getStationLists = () => {
    const self = this;
    api.get({
      path: '/station-lists',
      requestId: 'getAllStationLists',
      error() {
        self.setState({ hasError: true });
      },
      success(res) {
        self.setState({ stationLists: res });
        if (!self.state.selectedItemId) {
          self.setDefaultStationList();
        }
        const mappedStationLists = self.mapStationListsToGroups();
        self.setStationListOptions(mappedStationLists);
      },
    });
  }

  getBrandLogoUrl = () => getOrgLogoUrl();

  setDefaultStationList = () => {
    const { stationLists } = this.state;
    const { showAllStationsList, showWatchedStationsList } = this.props;

    if (stationLists.length) {
      if (showAllStationsList) {
        this.setSelectedStationListId(stationLists.find(list => list.list_type === 'allstations').id);
      } else if (showWatchedStationsList) {
        this.setSelectedStationListId(stationLists.find(list => list.list_type === 'watched').id);
      } else {
        this.setSelectedStationListId(stationLists.find(list => list.list_type !== 'allstations' || list.type !== 'watched').id);
      }
    }
  }

  getSelectedStationList = () => {
    const { selectedItemId, stationLists } = this.state;
    return stationLists.find(list => list.id === selectedItemId);
  }

  getSelectedItemName = () => {
    const stationList = this.getSelectedStationList();
    return stationList.name;
  }

  setSelectedStationListId = (stationListId) => {
    const { onStationListChange } = this.props;
    this.setState({ selectedItemId: stationListId });
    if (onStationListChange) {
      const stationList = this.getSelectedStationList();
      onStationListChange(stationList);
    }
  }

  setSelectedId = (id) => {
    this.setSelectedStationListId(id);
  }

  setIsOpen = (isOpen) => {
    this.setState({ isOpen });
  }

  generateOptionHtml = ({ id, name, station_count: stationCount }) => (<option value={id} key={id}>{`${name} (${stationCount})`}</option>);

  setStationListOptions = (mappedStationLists) => {
    const options = [];
    if (mappedStationLists) {
      if (mappedStationLists.allStationList) {
        const { allStationList } = mappedStationLists;
        options.push(this.generateOptionHtml(allStationList));
      }
      if (mappedStationLists.watchedStationsList) {
        const watchedStationList = mappedStationLists.watchedStationsList;
        options.push(this.generateOptionHtml(watchedStationList));
      }
      if (mappedStationLists.shared && mappedStationLists.shared.length > 0) {
        const groupOptions = mappedStationLists.shared.map(list => this.generateOptionHtml(list));
        options.push(<optgroup label="Shared" key="Shared">{groupOptions}</optgroup>);
      }
      if (mappedStationLists.private && mappedStationLists.private.length > 0) {
        const groupOptions = mappedStationLists.private.map(list => this.generateOptionHtml(list));
        options.push(<optgroup label="Private" key="Private">{groupOptions}</optgroup>);
      }
    }
    this.setState({ stationListOptions: options });
  }

  handleStationListSelectChange = (e) => {
    const { selectedIndex } = e.target;
    if (selectedIndex >= 0) {
      const listId = Number(e.target.options[selectedIndex].value);
      this.setSelectedStationListId(listId);
    }
  }

  handleSelectorOnClick = () => {
    const { isOpen } = this.state;
    this.setIsOpen(!isOpen);
  }

  handleOnOptionClick = (itemId) => {
    this.setState(() => ({
      selectedItemId: itemId,
      isOpen: false,
    }));
  }

  setDropdownContainer = (node) => {
    this.dropdownContainer = node;
  }

  globalOnClickHandle = (e) => {
    const { isOpen } = this.state;
    if (isOpen) {
      if (!this.dropdownContainer.contains(e.target)) {
        this.setIsOpen(false);
      }
    }
  }

  mapStationListsToGroups() {
    // map station lists into groups
    const { stationLists } = this.state;
    const { showAllStationsList, showWatchedStationsList } = this.props;

    const mappedStationLists = {
      allStationList: null,
      watchedStationsList: null,
      shared: [],
      private: [],
    };
    stationLists.forEach((stationList) => {
      switch (stationList.list_type) {
        case 'allstations':
          mappedStationLists.allStationList = (showAllStationsList ? stationList : null);
          break;
        case 'watched':
          mappedStationLists.watchedStationsList = (showWatchedStationsList ? stationList : null);
          break;
        case 'shared':
          mappedStationLists.shared.push(stationList);
          break;
        case 'private':
        default:
          mappedStationLists.private.push(stationList);
          break;
      }
    });
    mappedStationLists.station_lists_count = mappedStationLists.private.length
      + mappedStationLists.shared.length
      + (mappedStationLists.watchedStationsList ? 1 : 0)
      + (mappedStationLists.allStationList ? 1 : 0);

    return mappedStationLists;
  }


  render() {
    const { stationListOptions, isOpen, selectedItemId, stationLists } = this.state;
    let stationCount;
    const stationList = this.getSelectedStationList();
    if (stationList) {
      stationCount = `${stationList.station_count} Stations`;
    }
    const selectedItemName = (stationLists.length && selectedItemId) ? stationLists.find(list => list.id === selectedItemId).name : '';

    return (
      <div className={`${styles.stationListSelector} ${isOpen ? styles.opened : ''}`} ref={this.setDropdownContainer}>
        <div style={{ padding: '0 15px', display: 'flex' }}>
          {stationLists.length ? (
            <div className={styles.stationListToggleContainer} onClick={this.handleSelectorOnClick}>
              <div className={styles.selectedListName}>
                {selectedItemName}
              </div>
              <div className={styles.selectedListCount}>
                {`(${stationCount})`}
              </div>
              <div className={styles.chevronContainer}>
                <Chevron direction={isOpen ? 'up' : 'down'} size={12} />
              </div>
            </div>
          ) : (
            <div className={styles.loadingContainer}>
              <Loader className={styles.loader} />
              <div className={styles.loadingMessage}>Loading Station Lists</div>
            </div>
          )}
        </div>
        <ListDropdownWrapper
          selectedItemId={selectedItemId}
          selectedItemName={(stationLists.length && selectedItemId) ? stationLists.find(list => list.id === selectedItemId).name : ''}
          isOpen={isOpen}
          handleOnOptionClick={this.handleOnOptionClick}
          options={stationListOptions || []}
          onChange={this.handleStationListSelectChange}
          noOptionsMessage="No station lists found"
        />
      </div>
    );
  }
}

export default StationListSelector;
